/* eslint-disable react/no-unescaped-entities */
import React from 'react';

export const documentsLanguageContent = {
    'documents': {
        'en': 'Documents',
        'ar': 'وثائق',
        'ht': 'Dokiman yo',
        'pl': 'Dokumenty',
        'pt': 'Documentos',
        'sr': 'Документи',
        'es': 'Documentos',
        'vi': 'Các tài liệu',
        'zh': '文件',
        'ne': 'कागजातहरू'
    },
    'coming-soon': {
        'en': 'Coming Soon',
        'ar': 'قريباً',
        'ht': 'Vini byento',
        'pl': 'Wkrótce',
        'pt': 'Em breve',
        'sr': 'Долази ускоро',
        'es': 'Muy pronto',
        'zh': '即将推出',
        'ne': 'आउदैछ'
    },
    'use-view': {
        'en': <p className='text-[#333333] text-sm font-normal'>Use <b>View</b> to see the document in it's entirety.</p>,
        'ar': <p className='text-[#333333] text-sm font-normal'>استخدم <b>عرض</b> لرؤية المستند بالكامل.</p>,
        'ht': <p className='text-[#333333] text-sm font-normal'>Sèvi ak <b>View</b> pou wè dokiman an antye.</p>,
        'pl': <p className='text-[#333333] text-sm font-normal'>Użyj opcji <b>Wyświetl</b>, aby zobaczyć dokument w całości.</p>,
        'pt': <p className='text-[#333333] text-sm font-normal'>Use <b>Visualizar</b> para ver o documento na íntegra.</p>,
        'sr': <p className='text-[#333333] text-sm font-normal'>Користите <b>Приказ</b> да видите документ у целости.</p>,
        'es': <p className='text-[#333333] text-sm font-normal'>Utilice <b>Ver</b> para ver el documento en su totalidad.</p>,
        'vi': <p className='text-[#333333] text-sm font-normal'>Sử dụng <b>Xem</b> để xem toàn bộ tài liệu.</p>,
        'zh': <p className='text-[#333333] text-sm font-normal'>使用<b>查看</b>查看整个文档。</p>,
        'ne': <p className='text-[#333333] text-sm font-normal'>कागजातलाई पूर्ण रूपमा हेर्नको लागि <b>दृश्य</b> प्रयोग गर्नुहोस्।</p>
    },
    'indicates': {
        'en': 'Indicates a required field.',
        'ar': "يشير إلى الحقل المطلوب.",
        'ht': "Endike yon jaden obligatwa.",
        'pl': 'Wskazuje wymagane pole.',
        'pt': 'Indica um campo requerido.',
        'sr': 'Указује обавезно поље.',
        'es': 'Indica un campo obligatorio.',
        'vi': 'Cho biết một trường bắt buộc.',
        'zh': '表示必填字段。',
        'ne': 'आवश्यक क्षेत्रलाई संकेत गर्दछ।'
    },
    'acknowledge': {
        'en': 'It is recommended that any authorization form be read in its entirety. I acknowledge I was provided an opportunity to view the form in its entirety using the "View" option above.',
        'ar': `يوصى بقراءة أي نموذج تفويض بالكامل. أقر أنه قد أتيحت لي الفرصة لعرض النموذج بالكامل باستخدام خيار "عرض" أعلاه.`,
        'ht': `Li rekòmande pou li nenpòt fòm otorizasyon an antye. Mwen rekonèt mwen te bay yon opòtinite pou wè fòm nan antye lè l sèvi avèk opsyon "View" ki pi wo a.`,
        'pl': 'Zaleca się przeczytanie całego formularza autoryzacji. Potwierdzam, że miałem możliwość przejrzenia formularza w całości, korzystając z opcji „Wyświetl” powyżej.',
        'pt': 'Recomenda-se que qualquer formulário de autorização seja lido na íntegra. Reconheço que tive a oportunidade de visualizar o formulário na íntegra usando a opção "Visualizar" acima.',
        'sr': 'Препоручује се да се сваки образац овлашћења прочита у целости. Потврђујем да ми је пружена прилика да погледам образац у целости користећи горњу опцију „Прикажи“.',
        'es': 'Se recomienda leer en su totalidad cualquier formulario de autorización. Reconozco que se me brindó la oportunidad de ver el formulario en su totalidad usando la opción "Ver" arriba.',
        'vi': 'Chúng tôi khuyên bạn nên đọc toàn bộ bất kỳ biểu mẫu ủy quyền nào. Tôi xác nhận rằng tôi đã có cơ hội xem toàn bộ biểu mẫu bằng cách sử dụng tùy chọn "Xem" ở trên.',
        'zh': '建议完整阅读任何授权表格。我承认我有机会使用上面的“查看”选项查看完整的表格。',
        'ne': 'यो सिफारिस गरिएको छ कि कुनै पनि प्राधिकरण फारम यसको पूर्ण रूपमा पढ्नु पर्छ। माथिको "दृश्य" विकल्प प्रयोग गरेर मलाई फारम पूर्ण रूपमा हेर्ने अवसर प्रदान गरिएको थियो भनी म स्वीकार गर्छु।'
    },
    'user-name': {
        'en': 'Full Authorized User Name',
        'ar': "اسم المستخدم المعتمد بالكامل",
        'ht': "Non itilizatè otorize konplè",
        'pl': 'Pełna nazwa autoryzowanego użytkownika',
        'pt': 'Nome de usuário autorizado completo',
        'sr': 'Пуно овлашћено корисничко име',
        'es': 'Nombre de usuario autorizado completo',
        'vi': 'Tên người dùng được ủy quyền đầy đủ',
        'zh': '完整授权用户名',
        'ne': 'पूर्ण अधिकृत प्रयोगकर्ता नाम'
    },
    'user-name-placeholder': {
        'en': 'Enter authorized name',
        'ar': "أدخل الاسم المعتمد",
        'ht': "Antre non otorize",
        'pl': 'Wprowadź autoryzowaną nazwę',
        'pt': 'Digite o nome autorizado',
        'sr': 'Унесите овлашћено име',
        'es': 'Introduzca el nombre autorizado',
        'vi': 'Nhập tên được ủy quyền',
        'zh': '输入授权名称',
        'ne': 'अधिकृत नाम प्रविष्ट गर्नुहोस्'
    },
    'font': {
        'en': 'Font',
        'ar': "الخط",
        'ht': "Font",
        'pl': 'Czcionka',
        'pt': 'Fonte',
        'sr': 'Фонт',
        'es': 'Fuente',
        'vi': 'Nét chữ',
        'zh': '字体',
        'ne': 'फन्ट'
    },
    'user-initials': {
        'en': 'User Initials',
        'ar': "الأحرف الأولى للمستخدم",
        'ht': "Inisyal itilizatè yo",
        'pl': 'Inicjały użytkownika',
        'pt': 'Iniciais do usuário',
        'sr': 'Иницијали корисника',
        'es': 'Iniciales de usuario',
        'vi': 'Tên viết tắt của người dùng',
        'zh': '用户姓名缩写',
        'ne': 'प्रयोगकर्ता प्रारम्भिक'
    },
    'initials-placeholder': {
        'en': 'Enter initials',
        'ar': "أدخل الأحرف الأولى",
        'ht': "Antre inisyal yo",
        'pl': 'Wpisz inicjały',
        'pt': 'Insira as iniciais',
        'sr': 'Унесите иницијале',
        'es': 'Introduzca las iniciales',
        'vi': 'Nhập tên viết tắt',
        'zh': '输入姓名首字母',
        'ne': 'आद्याक्षरहरू प्रविष्ट गर्नुहोस्'
    },
    'clear': {
        'en': 'Clear',
        'ar': "واضح",
        'ht': "Klè",
        'pl': 'Jasne',
        'pt': 'Claro',
        'sr': 'Јасно',
        'es': 'Claro',
        'vi': 'Thông thoáng',
        'zh': '清除',
        'ne': 'खाली गर्नुहोस्'
    },
    'signing': {
        'en': 'Signing',
        'ar': "التوقيع",
        'ht': "Siyen",
        'pl': 'Podpisywanie',
        'pt': 'Assinatura',
        'sr': 'Потписивање',
        'es': 'Firma',
        'vi': 'Ký kết',
        'zh': '签约',
        'ne': 'हस्ताक्षर गर्दै'
    },
    'signing-warn': {
        'en': 'Signing in progress, please do not refresh or close your browser or navigate away from this page',
        'ar': "جاري تسجيل الدخول، يرجى عدم تحديث المتصفح أو إغلاقه أو الابتعاد عن هذه الصفحة",
        'ht': "Siyen nan pwogrè, tanpri pa rafrechi oswa fèmen navigatè ou a oswa navige lwen paj sa a",
        'pl': 'Trwa logowanie. Nie odświeżaj, nie zamykaj przeglądarki ani nie opuszczaj tej strony',
        'pt': 'Assinatura em andamento. Não atualize nem feche seu navegador nem saia desta página',
        'sr': 'Пријављивање је у току, молимо вас да не освежавате или затварате прегледач или да напуштате ову страницу',
        'es': 'Iniciando sesión, no actualice ni cierre su navegador ni salga de esta página',
        'vi': 'Đang trong quá trình đăng nhập, vui lòng không làm mới hoặc đóng trình duyệt của bạn hoặc điều hướng khỏi trang này',
        'zh': '正在登录，请不要刷新或关闭浏览器或离开此页面',
        'ne': 'साइन इन प्रगतिमा, कृपया ताजा वा आफ्नो ब्राउजर बन्द वा यस पृष्ठबाट टाढा नेभिगेट नगर्नुहोस्'
    }
}